const HTTP_URL = 'http://127.0.0.1:9933';
const WS_URL = 'ws://127.0.0.1:9944';
export default {
    HTTP_URL,
    WS_URL
};
